import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { HiMenu, HiX } from "react-icons/hi";
import Logo from "../../../components/Logo";

const NAV_LINKS = [
  { label: "About", target: "about" },
  { label: "Features", target: "features" },
  { label: "Team", target: "team" },
  { label: "Contact", target: "contact" },
];

function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (element) {
    const navbarHeight = 80;
    const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  }
}

export default function LandingNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (target) => {
    setMenuOpen(false);
    scrollToSection(target);
  };

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 dark:bg-[#181818]/95 backdrop-blur-sm shadow-lg"
          : "bg-white dark:bg-[#181818] shadow-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-[70px] sm:h-[80px]">
          <div className="flex-shrink-0 scale-[0.55] origin-left -my-4">
            <Logo />
          </div>

          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <button
                key={link.target}
                onClick={() => handleNavClick(link.target)}
                className="text-[#09062C] dark:text-white font-sans font-semibold text-[16px] hover:text-[#2A71E8] dark:hover:text-[#2A71E8] transition-colors"
              >
                {link.label}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/login"
              className="border rounded-[20px] py-2 px-6 border-[#cfcfcf] dark:border-gray-600 text-[#2A71E8] dark:text-white font-sans font-bold text-[15px] hover:border-[#2A71E8] transition-colors"
            >
              Log In
            </Link>
            <Link
              to="/register"
              className="bg-[#2A71E8] text-white font-sans font-bold text-[15px] px-6 py-2 rounded-[20px] hover:bg-[#1e5bb5] transition-colors"
            >
              Sign Up
            </Link>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden text-[#09062C] dark:text-white p-2"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
          >
            {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden bg-white dark:bg-[#181818] border-t border-gray-100 dark:border-gray-800"
          >
            <div className="px-4 py-4 flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.target}
                  onClick={() => handleNavClick(link.target)}
                  className="text-left text-[#09062C] dark:text-white font-sans font-semibold text-[16px] py-2 hover:text-[#2A71E8] transition-colors"
                >
                  {link.label}
                </button>
              ))}
              <div className="flex gap-3 mt-2 pt-3 border-t border-gray-100 dark:border-gray-800">
                <Link
                  to="/login"
                  className="flex-1 text-center border rounded-[20px] py-2 border-[#cfcfcf] dark:border-gray-600 text-[#2A71E8] dark:text-white font-sans font-bold text-[15px]"
                  onClick={() => setMenuOpen(false)}
                >
                  Log In
                </Link>
                <Link
                  to="/register"
                  className="flex-1 text-center bg-[#2A71E8] text-white font-sans font-bold text-[15px] py-2 rounded-[20px]"
                  onClick={() => setMenuOpen(false)}
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
